<template class="modal-cancel-leftovers">
<b-modal id="cancel-leftovers-modal" centered :hide-footer="true" :hide-header="true">
  <template v-slot:default="{ hide }">
    <p class="modal-title">Cancel Leftovers</p>
  </template>

  <div class="modal-text">
    <p>Cancelling leftovers will remove all scheduled leftovers that use this dish. Are you sure you want to cancel this dish?</p>
  </div>

  <template v-slot:modal-footer="{ hide, cancelLeftovers }">
    <div class="modal-actions-wrapper">
      <BaseButton class="btn-clear" @click="hide()">
        Go Back
      </BaseButton>
      <BaseButton class="btn-danger" @click="cancelLeftovers()">
        Cancel Leftovers
      </BaseButton>
    </div>
  </template>
</b-modal>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {
    async cancelLeftovers() {
      await this.$emit('remove-leftovers');
      this.hide();
    },
    hide() {
      this.$bvModal.hide('cancel-leftovers-modal');
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.modal-title {
  font-size: 1.7rem;
  font-weight: 600 !important;
  margin-bottom: 2.4rem;
}

.modal-body {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.modal-text {
  font-weight: 400;
  text-align: center;
}

.modal-actions-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0 2rem;

  .button.btn-clear.btn-clear {
    color: $color-action !important;
    font-weight: 400;
    margin-bottom: 1.5rem;
    margin-top: 3rem;
    text-transform: capitalize !important;
  }

  .btn-danger {
    background-color: $color-cancel-leftovers-modal-btn-bg;
    border-color: $color-cancel-leftovers-modal-btn-bg;
    border-radius: $base-border-radius;
    font-size: 1.7rem;
  }
}
</style>
